export default class PlanCustomer {
  constructor() {
    this.associatedStripeId = null;
    this.description = [];
    this.id = null;
    this.installmentIntervalsCount = 0;
    this.lastEditDate = null;
    this.name = null;
    this.opportunities = [];
    this.price = null;
    this.stripeId = null;
    this.tier = null;
  }

  loadData(payload) {
    this.associatedStripeId = payload.associatedStripeId;
    this.description = payload.description || [];
    this.id = payload.id;
    this.installmentIntervalsCount = payload.installmentIntervalsCount;
    this.lastEditDate = payload.lastEditDate;
    this.name = payload.name;
    this.opportunities = payload.opportunities || [];
    this.price = payload.price.toString();
    this.stripeId = payload.stripeId;
    this.tier = payload.tier;
    return this;
  }

  getOpportunities() {
    return this.opportunities ? this.opportunities.join('; ') : null;
  }

  getDescription() {
    return `• ${this.description.join('\n• ')}`;
  }

  getShortDescription() {
    return this.description.length ? `• ${this.description[0]}` : '';
  }
}
